export type ClassNameValue = string | false | null | undefined;

/** Joins truthy class-name fragments. Keeps component files free of ad-hoc string building. */
export function classNames(...values: readonly ClassNameValue[]): string {
  return values.filter((value): value is string => typeof value === "string" && value !== "").join(" ");
}
